import { TaskActionTypes } from "./task-types";
import SortActionTypes from "../sort/sort-types";

const INITIAL_STATE = {
    taskQueryRedux: {userId: 0, sortBy: "updatedDate", sortDesc: true, pageNumber: 1, pageSize: 10, filters:[{column: 'status', value: 'active', type: null}]},
    isFetchingTasks: false,
    isSubmittingTask: false,
    errorMessage: '',
    tasks: [],
    taskCount: {},
    projects: [],
    docPath: [],
    originalDocPath: [],
    docPathBlackline: [],
    pptDocument: null,
    isLoadingDocument: false,
    showDocViewerModal: false,

    groupTasksBy: 'Category',
    tasksGrouped: {'active': [], 'completed': [], 'archived': [], 'urgent': [], 'high': [], 'medium': [], 'low': [], 
                    'owner': [], 'editor': [], 'approver' : [], 'viewer': [], 'standard':[], 'word':[], 'excel':[], 
                    'powerpoint':[], 'actionable':[], 'nonactionable':[], 'none': []},
    selectedTasks: [],
    filteredAndSortedTasks: {'active': [], 'completed': [], 'archived': [], 'urgent': [], 'high': [], 'medium': [], 'low': [], 
                                'owner': [], 'editor': [], 'approver' : [], 'viewer': [], 'standard':[], 'word':[], 'excel':[], 
                                'powerpoint':[], 'actionable':[], 'nonactionable':[], 'none': []},
}

const taskReducer = (state = INITIAL_STATE, action) => {

    let newSelectedTasks = state.selectedTasks;
    
    switch (action.type) {
        
        case TaskActionTypes.RESET_TASKS:
            return {
                ...INITIAL_STATE,
            }

        case TaskActionTypes.SET_TASK_QUERY:
            return {
                ...state,
                taskQueryRedux: action.payload
            }

        case TaskActionTypes.FETCHING_TASKS_START:
            return {
                ...state,
                isFetchingTasks: true
            }
        case TaskActionTypes.FETCHING_TASKS_SUCCESS:
            return {
                ...state,
                isFetchingTasks: false
            }
        case TaskActionTypes.FETCHING_TASKS_FAILURE:
            return {
                ...state,
                isFetchingTasks: false,
                errorMessage: action.payload
            }

        case TaskActionTypes.SUBMIT_DOCUMENT_START:
            return {
                ...state,
                isSubmittingTask: true
            }
        case TaskActionTypes.SUBMIT_DOCUMENT_FINISH:
            return {
                ...state,
                isSubmittingTask: false,
                errorMessage: (action.payload === "Error, API Failure" ? action.payload : "")
            }
        case TaskActionTypes.SUBMIT_DOCUMENT_FAILURE:
            return {
                ...state,
                isSubmittingTask: false,
                errorMessage: action.payload
            }
        case TaskActionTypes.SET_TASKS:
            return {
                ...state,
                tasks: action.payload
            }
        case TaskActionTypes.SET_TASK_COUNT_AND_PROJECT_LIST:
            return {
                ...state,
                taskCount: action.payload.taskCount,
                projects: action.payload.projects
            }

        case TaskActionTypes.FETCHING_DOCUMENT_START:
            return {
                ...state,
                isLoadingDocument: true
            }
        case TaskActionTypes.FETCHING_DOCUMENT_FINISH:
            return {
                ...state,
                isLoadingDocument: false
            }
        case TaskActionTypes.FETCHING_DOCUMENT_FAILURE:
            return {
                ...state,
                isLoadingDocument: false,
            }
        case TaskActionTypes.SET_DOCPATH:
            return {
                ...state,
                docPath: action.payload,
                isLoadingDocument: false
            }
        case TaskActionTypes.SET_ORIGINAL_DOCPATH:
            return {
                ...state,
                originalDocPath: action.payload,
                isLoadingDocument: false
            }            
        case TaskActionTypes.SET_DOCPATH_BLACKLINE:
            return {
                ...state,
                docPathBlackline: action.payload,
                isLoadingDocument: false
            }
        case TaskActionTypes.SET_PPT_DOCUMENT_DETAILS:
            return {
                ...state,
                pptDocument: action.payload,
                isLoadingDocument: false
            }
        case TaskActionTypes.SET_SELECTED_TASKS:
            return {
                ...state,
                selectedTasks: action.payload,
            }
        case TaskActionTypes.ADD_SELECTED_TASKS:
            return {
                ...state,
                selectedTasks: [
                    ...state.selectedTasks,
                    action.payload
                ]
            }
        case TaskActionTypes.DELETE_SELECTED_TASKS:
            newSelectedTasks.splice(newSelectedTasks.indexOf(action.payload), 1);

            return {
                ...state,
                selectedTasks: [
                    ...newSelectedTasks
                ]
            }
        case TaskActionTypes.ADD_MULTIPLE_SELECTED_TASKS:
            return {
                ...state,
                selectedTasks: [
                    ...state.selectedTasks,
                    ...action.payload
                ]
            }
        case TaskActionTypes.DELETE_MULTIPLE_SELECTED_TASKS:
            action.payload.forEach((taskId) => {
                newSelectedTasks.splice(newSelectedTasks.indexOf(taskId), 1)
            })

            return {
                ...state,
                selectedTasks: [
                    ...newSelectedTasks
                ],
            }
        case TaskActionTypes.SET_GROUP_TASKS_BY:
            return {
                ...state,
                groupTasksBy: action.payload,
            }
        case TaskActionTypes.SET_TASKS_GROUPED:
            return {
                ...state,
                tasksGrouped: action.payload,
            }
        case TaskActionTypes.SET_FILTERED_AND_SORTED_TASKS:
            return {
                ...state,
                filteredAndSortedTasks: action.payload,
            }
        case SortActionTypes.CLEAR_ALL_GROUP_BYS:
            return {
                ...state,
                groupTasksBy: 'Category',
            }
        default:
            return state;
    }
}

export default taskReducer;
